import React from 'react'
import { PassedPlanets, CurrentPlanet, ToPassPlanets } from '../styles/planet'
import Planet from './Planet';

export default ({
  partPlanets, planets, isPassed, isShown, planetType, finishedRides, isCurrent,
}) => {

  const Planets = isPassed ? PassedPlanets : isCurrent ? CurrentPlanet : ToPassPlanets

  return (
    <Planets isShown={isShown}>
      {partPlanets.map((planet) => (
        <Planet
          key={planet.index}
          {...{
            isShown,
            isPassed,
            finishedRides,
            isCurrent: planet.type === planetType,
            className: planet.isLastPlanet ? "up" : planet.isFirstPlanet ? "down" : "mid",
            minRidesForNextPlanet: !planet.isLastPlanet && planets[planet.index + 1].minNumOfRides,
            nextPlanetType: !planet.isLastPlanet && planets[planet.index + 1].type,
            ...planet,
          }}
        />
      ))}
    </Planets>
  )
}